"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.buttonPropTypes = exports.Button = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icon = require("../Icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
/* eslint-disable react/jsx-props-no-spreading */

/**
 * Primary UI component for user interaction
 */
const Button = ({
  variant,
  size,
  icon,
  iconPosition,
  text,
  link,
  name,
  action,
  disabled,
  useCallback,
  handleCallback,
  onClick,
  className: classNameProp,
  ...props
}) => {
  const className = ['ccl__button', `ccl__button--${variant}`, `ccl__button--${size}`, icon ? 'ccl__button--has-icon' : '', icon && iconPosition ? `ccl__button--has-icon--${iconPosition}` : '', classNameProp].join(' ');
  const color = variant === 'digital-primary' || variant === 'secondary--inverse' || variant === 'tertiary--inverse' ? 'inverse' : 'interactive';

  // button or a link
  const Tag = link ? 'a' : 'button';
  const textIcon = icon !== '' && iconPosition === 'leading' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      type: icon,
      color: disabled ? `disabled` : color,
      size: "sm"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "ccl__button__text",
      children: text
    })]
  }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "ccl__button__text",
      children: text
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      type: icon,
      color: disabled ? `disabled` : color,
      size: "sm"
    })]
  });
  function handleClick(a) {
    // pass the action to the callback prop
    handleCallback(a);
  }

  // are we triggering a callback function or standard onClick event handler
  const thisOnClick = useCallback ? () => handleClick(action) : onClick;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Tag, {
    ...(link ? {
      href: link
    } : {
      type: 'button'
    }),
    disabled: disabled,
    className: className,
    onClick: thisOnClick,
    ...(name && {
      'data-nw-error-button': name
    }),
    ...(action && {
      'data-nw-action': action
    }),
    ...props,
    children: icon ? textIcon : /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: "ccl__button__text",
      children: text
    })
  });
};
exports.Button = Button;
const buttonPropTypes = exports.buttonPropTypes = {
  /**
   * What style of button is this?
   */
  variant: _propTypes.default.oneOf(['brand-primary', 'digital-primary', 'secondary', 'secondary--inverse', 'tertiary', 'tertiary--inverse']),
  /**
   * Which size button to render
   */
  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
  /**
   * What icon to use
   */
  icon: _propTypes.default.oneOf([undefined, ..._Icon.iconsList]),
  /**
   * Where to place the icon
   */
  iconPosition: _propTypes.default.oneOf(['', 'leading', 'trailing']),
  /**
   * Button text contents
   */
  text: _propTypes.default.string.isRequired,
  /**
   * Optional click handler
   */
  useCallback: _propTypes.default.bool,
  /**
   * Is the button disabled
   */
  disabled: _propTypes.default.bool,
  /**
   * Is the button a anchor link, if so provide the url to link to
   */
  link: _propTypes.default.string,
  /**
   * used for tracking purposes
   */
  name: _propTypes.default.string,
  /**
   * used for tracking purposes
   */
  action: _propTypes.default.string,
  handleCallback: _propTypes.default.func,
  /**
   * callback function to toggle the button open or closed
   */
  onClick: _propTypes.default.func,
  /**
   * optional className to add additional style properties ie. formatting, padding etc
   */
  className: _propTypes.default.string
};
Button.defaultProps = {
  variant: 'brand-primary',
  size: 'large',
  disabled: false,
  icon: '',
  iconPosition: 'trailing',
  useCallback: false,
  link: '',
  name: '',
  action: '',
  handleCallback: () => {},
  onClick: () => {}
};